// src/components/list/OfficeHours.tsx

import {
  Box,
  List,
  ListItemButton,
  ListItemText,
  ListSubheader,
} from '@mui/material'

import { FolderId } from '@/types/domain'

import { SORT_WEEKDAY, userLocales } from '../../api'

type OHItemProps = {
  disabled?: boolean
  status: string
  title: string
}

const OHItem = ({ disabled = false, status, title }: OHItemProps) => (
  <ListItemButton disabled={disabled}>
    <ListItemText sx={{ width: 0.5 }}>{status}</ListItemText>
    <ListItemText sx={{ width: 0.5 }}>{title}</ListItemText>
  </ListItemButton>
)

const FILTER_IS_REGULAR = item => item.exception !== 1
const FILTER_IS_HOLIDAY = item => item.exception === 1

type Props = {
  data: Array<{
    closed: number
    date_exception: string
    day_of_week: number
    end_time: string
    entity_id: number
    exception: number
    folder_id: FolderId
    name: string
    start_time: string
  }>
}

export const OfficeHours = ({ data }: Props) => {
  if (!data) return <Box />

  const hasHoliday = data.filter(FILTER_IS_HOLIDAY).length > 0

  return (
    <List>
      <ListSubheader>Betriebszeiten</ListSubheader>

      {data
        .filter(FILTER_IS_REGULAR)
        .sort(SORT_WEEKDAY)
        .map(item => {
          const { closed, day_of_week } = item
          let { end_time, start_time } = item

          const title = [
            'Montag',
            'Dienstag',
            'Mittwoch',
            'Donnerstag',
            'Freitag',
            'Samstag',
            'Sonntag',
          ][day_of_week - 1]

          if (!start_time) start_time = '00:00:00'
          if (!end_time) end_time = '00:00:00'
          start_time = start_time.slice(0, -3)
          end_time = end_time.slice(0, -3)

          const status =
            closed === 1 ? 'Geschlossen' : `${start_time} - ${end_time}`

          return (
            <OHItem
              disabled={closed === 1}
              key={title}
              status={status}
              title={title}
            />
          )
        })}

      {hasHoliday && <ListSubheader>Feiertage</ListSubheader>}

      {data.filter(FILTER_IS_HOLIDAY).map(item => {
        const { closed, date_exception, name } = item
        let { end_time, start_time } = item

        const dateFormat: Intl.DateTimeFormatOptions = {
          weekday: 'long',
          day: 'numeric',
          month: 'long',
          year: 'numeric',
        }

        const dateStr = new Date(date_exception).toLocaleString(
          userLocales,
          dateFormat
        )

        const title = `${dateStr} - ${name}`

        if (!start_time) start_time = '00:00:00'
        if (!end_time) end_time = '00:00:00'

        start_time = start_time.slice(0, -3)
        end_time = end_time.slice(0, -3)

        const status =
          closed === 1 ? 'Geschlossen' : `${start_time} - ${end_time}`

        return <OHItem key={dateStr} status={status} title={title} />
      })}
    </List>
  )
}
